import { RecognitionApplication } from "../RecognitionApplication";
import { RecognitionApplicationPanelAttachment } from "../RecognitionApplicationPanelAttachment";
import { RecognitionApplicationReviewAttachment } from "../RecognitionApplicationReviewAttachment";

export type RecognitionApplicationViewModel = Omit<
  RecognitionApplication,
  "reviewAttachments" | "panelAttachments"
> & {
  reviewAttachments: (RecognitionApplicationReviewAttachment & {
    isToDelete?: boolean;
  })[];
  panelAttachments: (RecognitionApplicationPanelAttachment & {
    isToDelete?: boolean;
  })[];
  newReviewAttachments: File[];
  newPanelAttachments: File[];
};

export const toViewModel = (
  application: RecognitionApplication
): RecognitionApplicationViewModel => {
  return {
    ...application,
    newReviewAttachments: [],
    newPanelAttachments: [],
  };
};

export const fromViewModel = (
  applicationViewModel: RecognitionApplicationViewModel
): {
  application: RecognitionApplication;
  newReviewAttachments: File[];
  newPanelAttachments: File[];
  deletedReviewAttachmentIds: string[];
  deletedPanelAttachmentIds: string[];
} => {
  const { newReviewAttachments, newPanelAttachments } = applicationViewModel;
  delete (applicationViewModel as any).newReviewAttachments;
  delete (applicationViewModel as any).newPanelAttachments;

  const application = {
    ...applicationViewModel,
    // clear down any extra properties that the back-end is not expecting
    // reviewAttachments: [],
    // panelAttachments: [],
    // attachments: [],
  };

  const deletedReviewAttachmentIds = applicationViewModel.reviewAttachments
    .filter((item) => item.isToDelete)
    .map((item) => item.id);

  const deletedPanelAttachmentIds = applicationViewModel.panelAttachments
    .filter((item) => item.isToDelete)
    .map((item) => item.id);

  return {
    application,
    newReviewAttachments,
    newPanelAttachments,
    deletedReviewAttachmentIds,
    deletedPanelAttachmentIds,
  };
};
